__turbopack_context__.v({
  "connectionLines": "LinesFields-module-scss-module__psH1JW__connectionLines",
  "connectionLinesButton": "LinesFields-module-scss-module__psH1JW__connectionLinesButton",
});
